export const platforms = [
	{id: 1, name: 'GEI'},
	{id: 2, name: 'VHE'},
]

export const ID_GEI = 1
export const ID_VHE = 2